import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CONFIG } from 'src/app/dataModels/config';
import { CONSTANTS, OPERATION } from 'src/app/dataModels/constants';
import { HelperService } from 'src/app/services/utils/helper.service';
import { map, takeWhile, retry, retryWhen, scan } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
/**
 * global service
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  /**
   * constructor to inject dependency
   * @param apiService instance of apiService
   * @param helperService instance of helperService
   */
  constructor(private apiService: ApiService, private helperService: HelperService) {}

  /**
   * get resources from the session data
   * if isReload is true, then make api call
   * @param resourceList list of resources required by the component
   */
  async getResources(resourceList) {
    const response = {} as any;
    const request = { objects: [] };
    for (const resource of resourceList) {
      request.objects.push(this.formRequestObj(resource));
    }
    const result = await lastValueFrom(
      this.apiService.msPost(CONFIG.GET_GLOBAL_HOMEBUNDLE, request).pipe(
        map((x) => {
          if (x && x.objects && resourceList && x.objects.length !== resourceList.length) {
            throw new Error('length mismatch');
          }
          return x;
        }),
        retry(3)
      )
    );
    if (result && result.status === CONSTANTS.SUCCESS && result.objects) {
      for (const resultObj of result.objects) {
        if (resultObj.key) {
          response[resultObj.key] = resultObj.json;
        }
      }
    }
    return await this.filterResource(resourceList, response);
  }

    /**
   * get facility Hierarchy
   * @param resource resource required by the component
   */
    async getFacilityResources(resourceList) {
      let response = {} as any;
      const request = { objects: [] };
      for (const resource of resourceList) {
        request.objects.push(this.formRequestObjForFacilityHrk(resource));
      }
      const result = await lastValueFrom(
        this.apiService.msPost(CONFIG.GET_GLOBAL_HOMEBUNDLE, request)
        .pipe(map((x) => {
            if (x && x.objects && resourceList && x.objects.length !== resourceList.length) {
              throw new Error('length mismatch');
            }
            return x;
          }),
          retry(3)
        )
      );

      console.log({checknewresult: result})
      if (result && result.status === CONSTANTS.SUCCESS && result.objects) {
        for (const resultObj of result.objects) {
          if (resultObj.key) {
            response[resultObj.key] = resultObj.json;
          } else {
            response = resultObj.json;;
          }
        }
      }
      return response;
     // return await this.filterResource(resourceList, response);
    }
  
    /**
   * get resources from the session data
   * if isReload is true, then make api call
   * @param resourceList list of resources required by the component
   */
    // async getFacilityHirachyForNewEnroll(resourceList) {
    //   const response = {} as any;
    //   const request = { objects: [] };
    //   for (const resource of resourceList) {
    //     request.objects.push(this.formRequestObj(resource));
    //   }
    //   const result = await lastValueFrom(
    //     this.apiService.msPost(CONFIG.GET_GLOBAL_HOMEBUNDLE, request).pipe(
    //       map((x) => {
    //         if (x && x.objects && resourceList && x.objects.length !== resourceList.length) {
    //           throw new Error('length mismatch');
    //         }
    //         return x;
    //       }),
    //       retry(3)
    //     )
    //   );
    //   if (result && result.status === CONSTANTS.SUCCESS && result.objects) {
    //     for (const resultObj of result.objects) {
    //       if (resultObj.key) {
    //         response[resultObj.key] = resultObj.json;
    //       }
    //     }
    //   }
    //   return await this.filterResource(resourceList, response);
    // }
  /**
   * form the request object
   * @param resource reosurce type
   */
  formRequestObj(resource) {
    const nameOfObj = resource.type === CONSTANTS.LOV ? 'GET_LOVS' : 'GET_HIERARCHY';
    return {
      name: nameOfObj,
      params: {
        key: resource.key,
        reload: 'true',
      },
    };
  }

  formRequestObjForFacilityHrk(resource) {
    const nameOfObj  = resource.type = 'GET_FACILITY_TYPE_MAP';
    return {
      name: nameOfObj,
      params:{
      hierarchyType: 'PRE-LOGIN'
      }
    };
  }

  /**
   * filter the resource based on active flag
   * if active flag is not ALL, then filter all Inactive resource items
   * i.e. Items with Active Flag 'Y' will be available for the components
   * @param resourceList resource list
   * @param responseData response
   */
  filterResource(resourceList, responseData) {
    let newResource = {};
    if (resourceList && resourceList.length > 0 && responseData && Object.keys(responseData).length === resourceList.length) {
      resourceList.forEach((resource) => {
        const resourceTemp = responseData[resource.key];
        if (resource.type === CONSTANTS.LOV) {
          const activeFlag = resource.activeFlag ? resource.activeFlag : 'Y';
          const filterData = [];
          if (activeFlag !== 'ALL') {
            for (const tempResource of resourceTemp) {
              if (tempResource.activeFlag && tempResource.activeFlag === activeFlag) {
                filterData.push(tempResource);
              }
            }
            newResource[resource.key] = filterData;
          } else {
            newResource[resource.key] = resourceTemp;
          }
        } else {
          newResource[resource.key] = resourceTemp;
        }
      });
    } else {
      newResource = responseData;
    }

    return newResource;
  }

  /**
   * get training schedule
   */
  async getTrainingSchedules() {
    const request = {
      objects: [
        {
          name: OPERATION.ADMIN.GET_TRAINING_SCHEDULE,
        },
      ],
    };

    let trainingScheduleList = [];

    const result = await lastValueFrom(this.apiService.msPost(CONFIG.MS_GET_GLOBAL_HOMEBUNDLE, request));
    if (this.helperService.isValidGetResult(result) && result.objects[0].json) {
      trainingScheduleList = result.objects[0].json;
      this.formatTrainingScheduleList(trainingScheduleList);
    }

    return trainingScheduleList;
  }

  /**
   * format training schedule list
   * @param trainingScheduleList training schedule list
   */
  formatTrainingScheduleList(trainingScheduleList) {
    for (const training of trainingScheduleList) {
      training.canEdit = true;
      training.canDelete = true;
      training.dateTime = `${training.trnDay} ${training.trnDate} ${training.trnTime}`;
      if (!this.helperService.IsNullOrEmpty(training.msxSeats) && !this.helperService.IsNullOrEmpty(training.registeredSeats)) {
        training.availableSeats = (+training.msxSeats - +training.registeredSeats).toString();
      }
    }
  }

  /**
   * perform smoke test
   * @param intfcFormSeq interface enrollment form seq
   * @param intfcFormKey interface enrollment form key
   * @param hl7Version hl7 version
   * @param hl7Message hl7 message
   */

  async smokeTest(intfcFormSeq, intfcFormKey, hl7Version, hl7Message) {
    const request = {
      intfcFormSeq: this.helperService.IsNullOrEmpty(intfcFormSeq) ? '' : intfcFormSeq,
      intfcFormKey: this.helperService.IsNullOrEmpty(intfcFormKey) ? '' : intfcFormKey,
      hl7Version,
      hl7Message: this.helperService.encodeToBase64(this.helperService.encodeFileStream(hl7Message)),
    };

    return await lastValueFrom(this.apiService.post(CONFIG.SMOKE_TEST, request));
  }

  /**
   * perform IMS Web Service
   * @param formValues imsWebService form values
   * @param cdcSchemaFlag indicate if cdcSchema has to be used
   */
  async imsServiceTest(formValues, cdcSchemaFlag) {
    const request = {
      webSvcAccountId: formValues.webSvcAccountId,
      webSvcAccountKey: formValues.webSvcAccountKey,
      facilityId: formValues.njiisFacilityId,
      transactionType: formValues.requestOption,
      cdcSchemaFlag,
    } as any;
    if (formValues.requestOption === 'PING') {
      request.echoText = formValues.echoText;
    } else {
      request.hl7Version = formValues.hl7Version;
      request.hl7Message = this.helperService.encodeToBase64(this.helperService.encodeFileStream(formValues.hl7Message));
    }

    return await lastValueFrom(this.apiService.post(CONFIG.IMS_SERVICE_TEST, request));
  }

  /**
   * Retrieve Address information
   * @param facilityId facilityId for which address will be obtained
   */
  async getAddress(facilityId) {
    const request = {
      objects: [
        {
          name: OPERATION.GLOBAL.GET_ADDRESS,
          params: {
            facilityId,
          },
        },
      ],
    };

    const result = await lastValueFrom(this.apiService.msPost(CONFIG.GET_GLOBAL_BUNDLE, request));

    const addressResult = {
      isError: false,
      address: {} as any,
      hasData: true,
    };

    if (result.status === CONSTANTS.SUCCESS || result.status === CONSTANTS.TRN_WARNING) {
      if (result.objects && result.objects.length > 0 && result.objects[0].json && result.objects[0].json.length > 0) {
        addressResult.address = result.objects[0].json[0];
      } else {
        addressResult.hasData = false;
      }
    } else {
      addressResult.isError = true;
    }

    return addressResult;
  }
}
